import Container from "Components/Container/Container";
import SectionHeader from "Components/SectionHeader/SectionHeader";
import FadeInAnimation from "Components/FadeInAnimation/FadeInAnimation";
import Reavel from "Components/Reveal/Reavel";
import logoAqbm from "assets/logo/logo_aqbm.png";
import facebookImage from "assets/images/facebook.png";

const Aqbm = () => {
  return (
    <div className="bg-gray-800 pb-10 pt-4" id="aqbm">
      <SectionHeader heading={"Découvrez l'AQBM"} />
      <div className="w-full mx-auto">
        <div className="grid grid-cols-1 gap-10 mb-8">
          <FadeInAnimation>
            <div className="flex flex-col lg:flex-row justify-center items-center gap-10 max-w-6xl mx-auto">
              {/* AQBM Logo */}
              <img
                alt="AQBM Logo"
                loading="lazy"
                className="h-48 object-contain p-4"
                src={logoAqbm}
              />
              <div>
                <Reavel>
                  <p className="text-white px-4">
                    L'AQBM, ou Association Québécoise de Babyfoot Multitable,
                    est une organisation dédiée à la promotion et à la pratique
                    du babyfoot au Québec. Son objectif principal est
                    d'organiser des tournois provinciaux pour rassembler les
                    passionnés de ce jeu emblématique. Ces compétitions
                    permettent aux joueurs de tous niveaux de s'affronter dans
                    un esprit de camaraderie et de compétition amicale. Grâce à
                    ses tournois, l'AQBM contribue à l'engouement croissant pour
                    le babyfoot, offrant ainsi une plateforme dynamique pour les
                    joueurs et renforçant la communauté autour de ce sport.
                  </p>
                </Reavel>
              </div>
            </div>
          </FadeInAnimation>
        </div>

        <div className="flex flex-row items-center justify-center gap-6 pb-4">
          {/* Facebook Link */}
          <a
            href="https://www.facebook.com/aqbmfoosball"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center"
          >
            <img
              loading="lazy"
              src={facebookImage}
              alt="Facebook"
              className="w-16 h-16"
            />
          </a>

          {/* Website Button */}
          <a
            href="https://www.aqbm.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg transition font-semibold"
          >
            Visiter le site de l'AQBM
          </a>
        </div>
      </div>
    </div>
  );
};

export default Aqbm;
